import React, { useState } from 'react';
import PlaceList from './PlaceList';
import { withRouter } from 'react-router-dom';
import PlaceFilter from '../Place/Filter/PlaceFilter';
import { numberOfItemsPerPage } from '../../constants/globals.js';

const Place = () => {
  const initialStateValues = {
    createdAtFrom: Date.now(),
    createdAtTo: Date.now(),
  };

  const [filters, setFilters] = useState(initialStateValues);
  const [postData, setPostData] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  return (
    <div className="wrapper-fade-in content-min-height mb-5 mt-2">
      <div className="container">
        <PlaceFilter
          saveFilters={(filters) => setFilters(filters)}
          initialValues={filters}
          initialStateValues={initialStateValues}
          savePostData={(postData) => setPostData(postData)}
          setResetData={setResetData}
          pageSize={pageSize}
        />
        <PlaceList
          postData={postData}
          resetData={resetData}
          setResetData={setResetData}
          activePage={activePage}
          pageSize={pageSize}
          setActivePage={setActivePage}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default withRouter(Place);
